import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface FOInitialSetupProperty {
  property: boolean;
  rooms: number;
  marketSegment: number;
  businessSource: number;
  rates: number;
  entries: number;
  currentStep: number;
  hideInitialSetup?: boolean;
}

const initialState: FOInitialSetupProperty = {
  property: false,
  rooms: 0,
  marketSegment: 0,
  businessSource: 0,
  rates: 0,
  entries: 0,
  currentStep: 0,
};

export const FOInitialSetupSlice = createSlice({
  name: 'foInitialSetup',
  initialState,
  reducers: {
    foInitialSetupUpdateStep: (
      state,
      action: PayloadAction<
        | {
            key: keyof Omit<
              FOInitialSetupProperty,
              'currentStep' | 'property' | 'hideInitialSetup'
            >;
            state: number;
          }
        | { key: 'property' | 'hideInitialSetup'; state: boolean }
      >,
    ) => ({
      ...state,
      [action.payload.key]: action.payload.state,
    }),
    foInitialSetupSetCurrentStep: (state, action: PayloadAction<number>) => ({
      ...state,
      currentStep: action.payload,
    }),
  },
});

export default FOInitialSetupSlice.reducer;

export const { foInitialSetupUpdateStep, foInitialSetupSetCurrentStep } =
  FOInitialSetupSlice.actions;
